import styled from "styled-components";
import { SIDEBAR_PROPS } from "./sidebar-layout.constants";


export const Container = styled.div`
  background-color: ${({ theme }) => theme.containers.main.backgroundColor};
  min-height: 100vh;
  overflow-x: hidden;
  padding: 0;
  padding-left: ${SIDEBAR_PROPS.SIDEBAR_CLOSE_WIDTH};
`;

export const Backdrop = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: ${SIDEBAR_PROPS.SIDE_BAR_Z_INDEX + 5};
`;


